import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnConfig } from '../dtc-prediction-accordian-table/dtc-prediction-accordian-table.component';
import { ServicecallService } from 'src/app/services';

@Component({
  selector: 'app-dtc-prediction-table',
  templateUrl: './dtc-prediction-table.component.html',
  styleUrl: './dtc-prediction-table.component.css'
})
export class DtcPredictionTableComponent {

  @Input() tableHeader: string;
  @Input() columns: ColumnConfig[] = [];
  @Input() set dtcListData(value: any[]) {
    this._dtcListData = value || [];
  }
  get dtcListData() {
    return this._dtcListData;
  }

  private _dtcListData: any[];
  
  isdtcListTable: boolean = true;
  vehicleListTableColumn: any;
  vehicleListTableData: any;
  breakDownRiskRanges: any;
  selectedDTC: string;
  selectedBrekdownRiskType: string;
  noramlParamRangeList: any[] = [];
  dtcWiseVehicleListDetails: any[] = [];
  tooltipInfo: string;
  selectedDTCDescription: string;

  constructor(public router: Router, private _sharedService: ServicecallService) { }

  ngOnInit() {
    this.tooltipInfo = this._sharedService.getConfiguration('dtcPrediction')?.cases?.dtcParamInfo ?? '';
    this.dtcWiseVehicleListDetails = this._sharedService.getConfiguration('dtcPrediction')?.cases?.dtcWiseVehicleListDetails ?? [];
    this.dtcWiseVehicleListDetails = this.dtcWiseVehicleListDetails?.map(dtcGroup => {
      return {
        ...dtcGroup,
        vehicleListTableData: dtcGroup?.vehicleListTableData?.map(vehicle => {
          const risk = parseFloat(vehicle?.breakdownRisk);

          return {
            ...vehicle,
            predictionState: this.getPredictionState(risk)
          };
        })
      };
    });
    this.vehicleListTableColumn = this._sharedService.getConfiguration('dtcPrediction')?.cases?.vehicleListTableColumn ?? {
      "vehicleChassis": "Vehicle",
      "predictionConfidence": "Prediction Confidence",
      "breakdownRisk": "Breakdown Risk",
      "window": "Window",
      "serviceestimate": "Service Estimate",
      "predictionState": "State"
    };
    this.breakDownRiskRanges = this._sharedService.getConfiguration('dtcPrediction')?.cases?.breakDownRiskRanges ?? {
      "low": "50",
      "medium": "70"
    };
  }

  /**
   * Gets prediction state
   * @param breakdownRisk 
   * @returns prediction state 
   */
  getPredictionState(breakdownRisk: number): 'high' | 'medium' | 'low' {
    if (breakdownRisk > 70) {
      return 'high';
    } else if (breakdownRisk > 50) {
      return 'medium';
    } else {
      return 'low';
    }
  }

  /**
   * Handles back
   */
  handleBack() {
    this.isdtcListTable = true;
  }

  /**
   * Tables action
   * @param event 
   */
  tableAction(event: any) {
    if (event?.type !== 'predictionConfidence') {
      this.selectedDTC = event?.item?.dtc;
      this.selectedDTCDescription = event?.item?.description;
      this.isdtcListTable = false;
      this.selectedBrekdownRiskType = '';
      this.vehicleListTableData = this.dtcWiseVehicleListDetails?.find(item => item?.dtc === this.selectedDTC)?.vehicleListTableData;
      this.noramlParamRangeList = this.dtcWiseVehicleListDetails?.find(item => item?.dtc === this.selectedDTC)?.noramlParamRangeList;
    }
    if (event?.type === 'predictionConfidence') {
      const edate = this.formatEdate(new Date());
      this.router.navigate(
        ['case/predictions'],
        {
          queryParams: {
            dtc: this.selectedDTC,
            vin: event?.item?.vehicleChassis,
            edate,
            risk: parseFloat(event?.item?.breakdownRisk),
            prediction: parseFloat(event?.item?.predictionConfidence),
            pageType: 'casePrediction'
          }
        }
      );
    } else if (event?.type === 'breakdownRiskHigh') {
      this._filterVehicleListTableData('high');
    } else if (event?.type === 'breakdownRiskLow') {
      this._filterVehicleListTableData('low');
    } else if (event?.type === 'breakdownRiskMedium') {
      this._filterVehicleListTableData('medium');
    }
  }

  /**
   * Filters vehicle list table data
   * @param type 
   */
  private _filterVehicleListTableData(type: string) {
    this.selectedBrekdownRiskType = type;
    if (type === 'low')
      this.vehicleListTableData = this.vehicleListTableData?.filter(item => parseFloat(item?.breakdownRisk) <= Number(this.breakDownRiskRanges?.low));
    else if (type === 'medium')
      this.vehicleListTableData = this.vehicleListTableData?.filter(item => (parseFloat(item?.breakdownRisk) > Number(this.breakDownRiskRanges?.low)) && (parseFloat(item?.breakdownRisk) <= Number(this.breakDownRiskRanges?.medium)));
    else if (type === 'high')
      this.vehicleListTableData = this.vehicleListTableData?.filter(item => parseFloat(item?.breakdownRisk) > Number(this.breakDownRiskRanges?.medium));
  }

  /**
   * Formats edate
   * @param date 
   * @returns edate 
   */
  private formatEdate(date: Date): string {
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }

}
